const state = {
  dia: {},
  historico: {},
  titulo: '',
  cnpj: ''
}

const mutations = {
  fillDataRelatorioDia (state, res) {
    state.dia = res.data
  },
  fillDataRelatorioHistorico (state, res) {
    state.historico = res.data
  },
  fillDataRelatorioHistorico7 (state, res) {
    state.historico = res.data.grafico
    state.titulo = res.data.titulo
  }
}

const actions = {
  createRelatorioGeracaoDia (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v1/relatorios/geracao/registrador', data).then((res) => {
      context.commit('fillDataRelatorioDia', res)
      return res
    })
  },
  createRelatorioHistoricoGeracaoDia (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v1/relatorios/historico/geracao/registrador', data).then((res) => {
      context.commit('fillDataRelatorioHistorico', res)
      return res
    })
  },
  createRelatorioGeracaoSeteDias (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v1/relatorios/setedias/geracao/registrador', data).then((res) => {
      context.commit('fillDataRelatorioHistorico7', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js